import { render, staticRenderFns } from "./RegResult.vue?vue&type=template&id=5648d17f&scoped=true"
import script from "./RegResult.vue?vue&type=script&lang=js"
export * from "./RegResult.vue?vue&type=script&lang=js"
import style0 from "./RegResult.vue?vue&type=style&index=0&id=5648d17f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648d17f",
  null
  
)

export default component.exports